import { Link, useLocation } from "react-router-dom";
import { ReactComponent as Card1 } from '../assets/images/card1.svg';
import { ReactComponent as UserIcon } from '../assets/images/people.svg';
import { ReactComponent as Dash } from "../assets/images/graph.svg";

const TABS = [
    { key: "dashboard", to: "/dashboard", label: "Dashboard", Icon: Dash },
    // { key: "dashboard_public", to: "/dashboard_public", label: "Dashboard", Icon: Dash },
    { key: "donations", to: "/donation_list", label: "อาหารบริจาค", Icon: Card1 },
    { key: "profile", to: "/profile", label: "ข้อมูลส่วนตัว", Icon: UserIcon },
];

export default function BottomBar() {
    const { pathname } = useLocation();
     const active =
        pathname.startsWith("/dashboard")
            ? "dashboard"
            : pathname.startsWith("/profile")
                ? "profile"
                : "donations";

    return (
        <nav
            id="bottombar"
            className="fixed bottom-0 left-1/2 -translate-x-1/2 z-[9999] w-full max-w-[430px] pt-2 pb-[calc(env(safe-area-inset-bottom,0)+0px)]"
        >
            <div className="bg-white rounded-t-3xl ring-1 ring-[#F5F5F5]">
                <ul className="grid grid-cols-3">
                    {TABS.map(({ key, to, label, Icon }) => {
                        const isActive = key === active;
                        return (
                            <li key={key}>
                                <Link to={to} className="flex flex-col items-center justify-center gap-1 py-3">
                                    <div className="grid place-items-center w-10 h-10 rounded-2xl">
                                        <Icon className={isActive ? "text-[#009951] w-8 h-8" : "text-[#9CA3AF] w-8 h-8"} />
                                    </div>
                                    <span className={`text-xs ${isActive ? "text-[#009951] font-semibold" : "text-[#9CA3AF]"}`}>
                                        {label}
                                    </span>
                                </Link>
                            </li>
                        );
                    })}
                </ul>
            </div>
        </nav>
    );
}
